<template>
  <ModalDialog
    ref="dialog"
    title="Create Purchased Product"
    icon="fa-money-check-alt"
    :submitting="submitting"
    submitTitle="Create"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="form" :labelColumnSize="2">
      <ContentTitle>Product</ContentTitle>

      <div>
        <FormRow label="Product Link">
          <FormSelect :options="productLookup" v-model="product.billingProductId" />
        </FormRow>
        <FormRow label="Product Quantity">
          <FormInputText type="number" v-model="product.quantity" />
        </FormRow>
      </div>
      
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'DeveloperPurchaseProductDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    accountId: Number
  },
  data() {
    return {
      product: { },
      form: {},
      billingProductList: [],
      submitting: false
    }
  },
  mounted() {
    this.requestData()
  },
  computed: {
    productLookup() {
      return _.concat(
        [{ value: 0, name: 'None' }]
      , this.billingProductList
      .filter(billingProduct => {
        if(!billingProduct.isActive)
          return false

        // Only use products that have one_time pricing (ie, not subscription based)
        if(_.isArray(billingProduct.priceInfoList) && billingProduct.priceInfoList.length > 0) {
          if(!billingProduct.priceInfoList.every(priceInfo => priceInfo.interval == 'one_time'))
            return false
        } else {
          // No pricing info defined. Ignore it
          return false
        }

        return true
      })
      .map(billingProduct => {
        return {
          value: billingProduct.id,
          name: `${billingProduct.name} - ${billingProduct.description}`
        }
      }))
    }
  },
  methods: {
    show() {
      // Reset form
      this.product = {
        quantity: 1,
        billingProductId: 0
      }
      this.form = {}
      this.submitting = false

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var createData = {
        quantity: this.product.quantity,
        billingProductId: this.product.billingProductId
      }

      this.$apiService.developerService.developerCreatePurchasedProduct(this.accountId, createData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.form = this.processFormResponse(err)
        })
    },
    requestData() {
      this.$apiService.developerService.developerGetBillingProducts()
      .then(response => {
        this.billingProductList = response.data
      })
    }
  }
}
</script>